import React from 'react';
import { FaWifi, FaConciergeBell, FaUtensils } from 'react-icons/fa';
import { MdLocalLaundryService } from 'react-icons/md';
import wifiImg from '../assets/img/rooms/4.jpg';
import restaurantImg from '../assets/img/restaSlider/restaurent.jpg';

const features = [
  {
    icon: MdLocalLaundryService,
    title: 'Laundry Services',
    image:
      'https://images.unsplash.com/photo-1545173168-9f1947eebb7f?w=800&q=75&auto=format&fit=crop',
  },
  {
    icon: FaWifi,
    title: 'Wifi Connectivity',
    image: wifiImg,
  },
  {
    icon: FaConciergeBell,
    title: 'Available on Request',
    image:
      'https://commons.wikimedia.org/wiki/Special:FilePath/Ring%20Bell%20For%20Service%20-%20Photo%20A%20Day%207%209%202009%20(3706152960).jpg?width=800',
  },
  {
    icon: FaUtensils,
    title: 'Restaurant',
    image: restaurantImg,
  },
];

const YChoose = () => {
  return (
    <section className="pt-0 lg:pt-4 pb-4 lg:pb-8" style={{ background: '#FFFFE7' }}>
      <div className="container mx-auto lg:px-0 rounded-3xl p-4 sm:p-6 shadow-xl bg-white/80">
        <div className="text-center mb-6 sm:mb-8">
          <div className="font-tertiary uppercase text-lg sm:text-[25px] tracking-[3px] sm:tracking-[6px]">
            Home Page
          </div>
          <h2 className="font-primary text-3xl sm:text-4xl lg:text-[45px]">Why Choose Our Hotel</h2>
          <p className="text-gray-500 mt-2 max-w-xl mx-auto text-sm sm:text-base px-2">
            Modern amenities. Thoughtful services. A memorable stay.
          </p>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-4 lg:gap-6">
          {features.map(({ icon: Icon, title, image }) => (
            <div
              key={title}
              className="relative h-40 sm:h-56 md:h-64 rounded-2xl overflow-hidden shadow-lg bg-primary group"
            >
              <img
                src={image}
                alt={title}
                loading="lazy"
                className="absolute inset-0 w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                onError={(event) => {
                  event.currentTarget.style.display = 'none';
                }}
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/40 to-black/10" />
              <div className="absolute inset-0 flex flex-col items-center justify-center text-white text-center px-2 sm:px-3">
                <span className="w-10 h-10 sm:w-14 sm:h-14 rounded-full bg-accent flex items-center justify-center mb-2 sm:mb-3 shadow-md">
                  <Icon className="text-lg sm:text-2xl text-white" />
                </span>
                <span className="font-primary text-xs sm:text-base md:text-lg font-bold uppercase tracking-wide leading-snug">
                  {title}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default YChoose;
